import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt", "width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createBlock(_component_v_avatar, {
    color: "gray",
    size: _ctx.size,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.srcImg,
        alt: _ctx.alt,
        width: _ctx.size,
        height: _ctx.size,
        loading: "lazy"
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["size"]))
}